import React, { useState, useEffect } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ContainerAccordion, { AccordionDetails, AccordionSummary } from './ContainerAccordion';
import { CircularProgress } from '@material-ui/core';
import DeviceInfo from './DeviceInfo';
import BreathingText from './BreathingText';
import Collapse from '@material-ui/core/Collapse'

const ContainerInfo = ({
    name,
    data,
    vsId,
    container_index,
    fetchContainerInfo,
}) => {
    const [expanded, setExpanded] = useState(false);
    useEffect(() => {
        expanded && fetchContainerInfo(vsId, container_index);
    }, [expanded]);

    return <ContainerAccordion expanded={expanded}>
        <AccordionSummary onClick={() => setExpanded(!expanded)} expandIcon={<ExpandMoreIcon />}>
            <div style={{ display: 'inline', overflow:'visible' }}>
                {name}
            </div>
            <div style={{ display: 'inline' }}>
                {data['loading'] && <CircularProgress size={16} style={{ marginLeft: '10px' }} />}
            </div>
        </AccordionSummary>
        <AccordionDetails>
            {data['loading'] ? <BreathingText style={{marginLeft:'20px', fontStyle:'italic', fontWeight:'300'}}>Loading...</BreathingText> :
                data['devices'] && data['devices'].map(device =>
                    <Collapse in={true} appear={true} timeout={300} key={device['device_id']}><div>
                    <ContainerAccordion defaultExpanded={device.connection_state === 'Connected'}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {device['device_id']}
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div style={{marginTop:'-8px', paddingLeft:'35px'}}>
                                <DeviceInfo device={device} />
                            </div>
                        </AccordionDetails>
                    </ContainerAccordion>
                    </div></Collapse>
                )}
        </AccordionDetails>
    </ContainerAccordion>
}

export default ContainerInfo;